// import {
//   Card, Typography, IconButton, Box, Button,
//   CardMedia, Chip, Collapse, FormControl, RadioGroup,
//   FormControlLabel, Radio, Checkbox, FormGroup, Divider,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import RemoveIcon from "@mui/icons-material/Remove";
// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// import TuneIcon from "@mui/icons-material/Tune";
// import CloseIcon from "@mui/icons-material/Close";
// import { useDispatch, useSelector } from "react-redux";
// import { addItem, removeItem } from "../../redux/slices/cartSlice";
// import { useState, useEffect, useMemo } from "react";

// const VegDot = ({ isVeg }) => (
//   <Box sx={{
//     width: 16, height: 16, borderRadius: "3px",
//     border: `2px solid ${isVeg ? "#2e7d32" : "#c62828"}`,
//     display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
//   }}>
//     <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: isVeg ? "#2e7d32" : "#c62828" }} />
//   </Box>
// );

// const MenuItemCard = ({
//   item,
//   sx,
//   categoryName,
//   itemOffer = null,
//   categoryOffer = null,
//   isBogoEligible = false
// }) => {
//   const dispatch = useDispatch();

//   const [showCustomization, setShowCustomization] = useState(false);
//   const [selectedSize, setSelectedSize] = useState(null);
//   const [selectedVariant, setSelectedVariant] = useState(null);
//   const [selectedAddons, setSelectedAddons] = useState([]);
//   const [imgError, setImgError] = useState(false);
//   const originalPrice = useMemo(() => {
//     return Number(item.basePrice || item.price || 0);
//   }, [item.basePrice, item.price]);
//   const [bestOffer, setBestOffer] = useState(null);
//   const [discountedPrice, setDiscountedPrice] = useState(null);
//   const [savingAmount, setSavingAmount] = useState(0);

//   const cartItem = useSelector((state) =>
//     state.cart?.items?.find((i) => i._id === item._id)
//   );
//   const quantity = cartItem?.qty || 0;

//   const hasCustomization =
//     item.sizes?.length > 0 || item.variants?.length > 0 || item.addonGroups?.length > 0;

//   useEffect(() => {
//     let bestDiscount = 0;
//     let bestOfferData = null;
//     if (itemOffer && itemOffer.offerCategory === "DISCOUNT" && itemOffer.scope === "ITEM") {
//       let discount = 0;
//       if (itemOffer.discountType === "PERCENT") {
//         discount = (originalPrice * itemOffer.value) / 100;
//         if (itemOffer.maxDiscount && discount > itemOffer.maxDiscount) {
//           discount = itemOffer.maxDiscount;
//         }
//       } else {
//         discount = Math.min(itemOffer.value, originalPrice);
//       }

//       if (discount > bestDiscount) {
//         bestDiscount = discount;
//         bestOfferData = {
//           ...itemOffer,
//           discountAmount: discount,
//           type: "ITEM",
//           saving: discount
//         };
//       }
//     }

//     // Check category level discount offers
//     if (categoryOffer && categoryOffer.offerCategory === "DISCOUNT") {
//       let discount = 0;
//       if (categoryOffer.discountType === "PERCENT") {
//         discount = (originalPrice * categoryOffer.value) / 100;
//         if (categoryOffer.maxDiscount && discount > categoryOffer.maxDiscount) {
//           discount = categoryOffer.maxDiscount;
//         }
//       } else {
//         discount = Math.min(categoryOffer.value, originalPrice);
//       }

//       if (discount > bestDiscount) {
//         bestDiscount = discount;
//         bestOfferData = {
//           ...categoryOffer,
//           discountAmount: discount,
//           type: "CATEGORY",
//           saving: discount
//         };
//       }
//     }

//     if (bestDiscount > 0) {
//       setBestOffer(bestOfferData);
//       setDiscountedPrice(originalPrice - bestDiscount);
//       setSavingAmount(bestDiscount);
//     } else {
//       setBestOffer(null);
//       setDiscountedPrice(null);
//       setSavingAmount(0);
//     }
//   }, [itemOffer, categoryOffer, originalPrice, item.itemName]);

//   const calculateFinalPrice = () => {
//     let price = discountedPrice !== null ? discountedPrice : originalPrice;
//     let finalSaving = savingAmount;

//     if (selectedSize && item.sizes) {
//       const s = item.sizes.find((s) => s.name === selectedSize);
//       if (s) {
//         price = s.price;
//         if (bestOffer && bestOffer.discountType === "PERCENT") {
//           let discount = (price * bestOffer.value) / 100;
//           if (bestOffer.maxDiscount && discount > bestOffer.maxDiscount) {
//             discount = bestOffer.maxDiscount;
//           }
//           price = price - discount;
//           finalSaving = discount;
//         } else if (bestOffer && bestOffer.discountType === "FLAT") {
//           price = Math.max(0, price - bestOffer.value);
//           finalSaving = bestOffer.value;
//         }
//       }
//     }

//     if (selectedVariant && item.variants) {
//       const v = item.variants.find((v) => v.name === selectedVariant);
//       if (v?.price) price += v.price;
//     }

//     if (selectedAddons.length > 0) {
//       price += selectedAddons.reduce((sum, addonName) => {
//         for (const group of item.addonGroups || []) {
//           const a = group.items?.find((a) => a.name === addonName);
//           if (a) return sum + a.price;
//         }
//         return sum;
//       }, 0);
//     }

//     return price;
//   };

//   const handleAdd = () => {
//     if (hasCustomization && !showCustomization) {
//       setShowCustomization(true);
//       return;
//     }

//     if (item.sizes?.length > 0 && !selectedSize) {
//       alert("Please select a size");
//       return;
//     }
//     if (item.variants?.length > 0 && !selectedVariant) {
//       alert("Please select a variant");
//       return;
//     }
//     for (const group of item.addonGroups || []) {
//       if (group.required && group.items?.length > 0) {
//         const ok = selectedAddons.some((addon) => group.items.some((a) => a.name === addon));
//         if (!ok) {
//           alert(`Please select from "${group.title}"`);
//           return;
//         }
//       }
//     }

//     // Calculate prices
//     let itemOriginalPrice = 0;
//     let itemFinalPrice = 0;

//     // Size price
//     if (selectedSize && item.sizes) {
//       const size = item.sizes.find(s => s.name === selectedSize);
//       if (size) {
//         itemOriginalPrice += size.price;
//         itemFinalPrice += size.price;
//       }
//     } else {
//       itemOriginalPrice += Number(item.basePrice || item.price || 0);
//       itemFinalPrice += Number(item.basePrice || item.price || 0);
//     }

//     // Variant price
//     if (selectedVariant && item.variants) {
//       const variant = item.variants.find(v => v.name === selectedVariant);
//       if (variant?.price) {
//         itemOriginalPrice += variant.price;
//         itemFinalPrice += variant.price;
//       }
//     }

//     // Addons price
//     if (selectedAddons.length > 0) {
//       selectedAddons.forEach(addonName => {
//         for (const group of item.addonGroups || []) {
//           const addon = group.items?.find(a => a.name === addonName);
//           if (addon) {
//             itemOriginalPrice += addon.price;
//             itemFinalPrice += addon.price;
//           }
//         }
//       });
//     }

//     // Apply discount if any
//     let discountAmount = 0;
//     let appliedOfferData = null;

//     if (bestOffer) {
//       if (bestOffer.discountType === "PERCENT") {
//         discountAmount = (itemFinalPrice * bestOffer.value) / 100;
//         if (bestOffer.maxDiscount && discountAmount > bestOffer.maxDiscount) {
//           discountAmount = bestOffer.maxDiscount;
//         }
//       } else {
//         discountAmount = Math.min(bestOffer.value, itemFinalPrice);
//       }

//       itemFinalPrice = itemFinalPrice - discountAmount;
//       appliedOfferData = {
//         offerId: bestOffer._id,
//         offerCode: bestOffer.offerCode,
//         offerTitle: bestOffer.title,
//         discountType: bestOffer.discountType,
//         discountValue: bestOffer.value,
//         discountAmount: discountAmount,
//         isFree: false
//       };
//     }

//     // dispatch(addItem({
//     //   ...item,
//     //   price: itemFinalPrice,
//     //   originalPrice: itemOriginalPrice,
//     //   totalPrice: itemFinalPrice,
//     //   discountedPrice: itemFinalPrice,
//     //   discountAmount: discountAmount,
//     //   selectedSize,
//     //   selectedVariant,
//     //   selectedAddons: selectedAddons.map((name) => {
//     //     for (const group of item.addonGroups || []) {
//     //       const a = group.items?.find((a) => a.name === name);
//     //       if (a) return { name: a.name, price: a.price };
//     //     }
//     //     return { name, price: 0 };
//     //   }),
//     //   categoryName: categoryName || item.categoryName,
//     //   qty: 1,
//     //   appliedOffer: appliedOfferData,
//     //   isBogoEligible: isBogoEligible,
//     //   savingPerItem: discountAmount,
//     //   savingTotal: discountAmount,
//     //   hasOffer: bestOffer !== null,
//     //   offerType: bestOffer?.type,
//     // }));

//     dispatch(addItem({
//   ...item,
//   // 🔥 ADD: categoryId (ye zaroori hai)
//   categoryId: item.categoryId || item.category?._id || item.category,
//   price: itemFinalPrice,
//   originalPrice: itemOriginalPrice,
//   totalPrice: itemFinalPrice,
//   discountedPrice: itemFinalPrice,
//   discountAmount: discountAmount,
//   selectedSize,
//   selectedVariant,
//   selectedAddons: selectedAddons.map((name) => {
//     for (const group of item.addonGroups || []) {
//       const a = group.items?.find((a) => a.name === name);
//       if (a) return { name: a.name, price: a.price };
//     }
//     return { name, price: 0 };
//   }),
//   categoryName: categoryName || item.categoryName,
//   qty: 1,
//   appliedOffer: appliedOfferData,
//   isBogoEligible: isBogoEligible,
//   savingPerItem: discountAmount,
//   savingTotal: discountAmount,
//   hasOffer: bestOffer !== null,
//   offerType: bestOffer?.type,
// }));
//     setShowCustomization(false);
//   };

//   const handleRemove = () => {
//     if (quantity > 0) dispatch(removeItem(item._id));
//   };

//   const handleAddonChange = (addonName, group) => {
//     if (group.multiSelect) {
//       setSelectedAddons((prev) =>
//         prev.includes(addonName) ? prev.filter((a) => a !== addonName) : [...prev, addonName]
//       );
//     } else {
//       setSelectedAddons([addonName]);
//     }
//   };

//   const itemImage = (!imgError && item.image) ? item.image : null;
//   const displayPrice = discountedPrice !== null ? discountedPrice : originalPrice;
//   const hasOffer = bestOffer !== null || isBogoEligible;
//   const isOutOfStock = item.isAvailable === false;
//   return (
//     <Card
//       elevation={0}
//       sx={{
//         display: "flex", flexDirection: "column", width: "100%",
//         bgcolor: "white", borderRadius: 0,
//         opacity: isOutOfStock ? 0.7 : 1,
//         ...sx,
//       }}
//     >
//       <Box sx={{ display: "flex", p: 1.5, gap: 1.5, alignItems: "flex-start" }}>

//          {/* ── Left: Text content ── */}
//         <Box sx={{ flex: 1, minWidth: 0,}}>
//           {/* Veg dot + Name */}
//           <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.8, mb: 0.5 }}>
//             <Box sx={{ mt: 0.3, flexShrink: 0 }}>
//               <VegDot isVeg={item.isVeg} />
//             </Box>
//             <Typography
//               variant="subtitle2"
//               sx={{
//                 fontWeight: 700, fontSize: "0.9rem", color: "#1a1a1a",
//                 lineHeight: 1.3, wordBreak: "break-word",
//               }}
//             >
//               {item.itemName} 
//             </Typography>
//           </Box>

//           {/* Price row with discount - FIXED */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5, flexWrap: "wrap" }}>
//             <Typography sx={{
//               fontWeight: 700,
//               fontSize: "0.95rem",
//               color: discountedPrice !== null ? "#2e7d32" : "#1a1a1a"
//             }}>
//               ₹{displayPrice.toFixed(0)}
//             </Typography>
            
//             {discountedPrice !== null && discountedPrice < originalPrice && (
//               <>
//                 <Typography sx={{
//                   fontSize: "0.78rem",
//                   color: "#aaa",
//                   textDecoration: "line-through"
//                 }}>
//                   ₹{originalPrice.toFixed(0)}
//                 </Typography>
                
//                 {/* 🔥 SAVINGS BADGE */}
//                 <Chip
//                   label={`Save ₹${savingAmount.toFixed(0)}`}
//                   size="small"
//                   sx={{
//                     height: 18,
//                     fontSize: "0.6rem",
//                     bgcolor: "#e8f5e9",
//                     color: "#2e7d32",
//                     fontWeight: 700
//                   }}
//                 />
//               </>
//             )}
//           </Box>

//           {/* Description */}
//           {item.description && (
//             <Typography
//               variant="caption"
//               sx={{
//                 color: "#888", fontSize: "0.75rem", display: "-webkit-box",
//                 WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden",
//                 lineHeight: 1.4, mb: 0.5,
//               }}
//             >
//               {item.description}
//             </Typography>
//           )}

//           {/* Tags row - FIXED with better display */}
//           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 0.5 }}>
//             {hasCustomization && (
//               <Chip
//                 label="Customisable"
//                 size="small"
//                 icon={<TuneIcon sx={{ fontSize: "11px !important", ml: "4px !important" }} />}
//                 sx={{
//                   height: 19, fontSize: "0.62rem", fontWeight: 600,
//                   bgcolor: "#fff8e1", color: "#f57c00",
//                   border: "1px solid #ffe0b2",
//                   "& .MuiChip-icon": { color: "#f57c00" },
//                 }}
//               />
//             )}
            
//             {/* DISCOUNT OFFER BADGE */}
//             {bestOffer && (
//               <Chip
//                 label={
//                   bestOffer.discountType === "PERCENT"
//                     ? `${bestOffer.value}% OFF`
//                     : `₹${bestOffer.value} OFF`
//                 }
//                 size="small"
//                 icon={<LocalOfferIcon sx={{ fontSize: "11px !important", ml: "4px !important" }} />}
//                 sx={{
//                   height: 19, fontSize: "0.62rem", fontWeight: 700,
//                   bgcolor: "#e8f5e9", color: "#2e7d32",
//                   border: "1px solid #c8e6c9",
//                   "& .MuiChip-icon": { color: "#2e7d32" },
//                 }}
//               />
//             )}
            
//             {/* BOGO OFFER BADGE */}
//             {isBogoEligible && !bestOffer && (
//               <Chip
//                 label="BOGO"
//                 size="small"
//                 icon={<LocalOfferIcon sx={{ fontSize: "11px !important", ml: "4px !important" }} />}
//                 sx={{
//                   height: 19, fontSize: "0.62rem", fontWeight: 700,
//                   bgcolor: "#fff3e0", color: "#e65100",
//                   border: "1px solid #ffe0b2",
//                   "& .MuiChip-icon": { color: "#e65100" },
//                 }}
//               />
//             )}
//           </Box>
//         </Box>

//         {/* ── Right: Image + Add button ── */}
//         <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0, width: 100 }}>
//           {/* Image with offer badge */}
//           <Box sx={{ position: "relative", width: 100, height: 100, borderRadius: 2, overflow: "hidden", bgcolor: "#f5f5f5", mb: 1 }}>
//             {itemImage ? (
//               <CardMedia
//                 component="img"
//                 image={itemImage}
//                 alt={item.itemName}
//                 onError={() => setImgError(true)}
//                 sx={{ width: "100%", height: "100%", objectFit: "cover" }}
//               />
//             ) : (
//               <Box sx={{
//                 width: "100%", height: "100%",
//                 display: "flex", alignItems: "center", justifyContent: "center",
//                 fontSize: "2rem", bgcolor: item.isVeg ? "#f1f8e9" : "#fce4ec",
//               }}>
//                 {item.isVeg ? "🥗" : "🍗"}
//               </Box>
//             )}

//             {/* 🔥 OFFER BADGE ON IMAGE */}
//             {hasOffer && (
//               <Box sx={{
//                 position: "absolute", top: 0, left: 0, right: 0,
//                 bgcolor: bestOffer ? "#ff9800" : "#e91e63",
//                 py: 0.2, textAlign: "center",
//               }}>
//                 <Typography sx={{ color: "white", fontSize: "0.55rem", fontWeight: 800, letterSpacing: 0.3 }}>
//                   {bestOffer
//                     ? `${bestOffer.value}${bestOffer.discountType === "PERCENT" ? "%" : "₹"} OFF`
//                     : "BOGO"}
//                 </Typography>
//               </Box>
//             )}

//             {/* Bestseller ribbon */}
//             {item.isBestseller && !hasOffer && (
//               <Box sx={{
//                 position: "absolute", top: 0, left: 0, right: 0,
//                 bgcolor: "#e65100", py: 0.2, textAlign: "center",
//               }}>
//                 <Typography sx={{ color: "white", fontSize: "0.55rem", fontWeight: 800, letterSpacing: 0.3 }}>
//                   ⭐ BESTSELLER
//                 </Typography>
//               </Box>
//             )}

//             {/* 🔥 OUT OF STOCK BADGE */}
//             {isOutOfStock && (
//               <Box sx={{
//                 position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
//                 bgcolor: "rgba(0,0,0,0.6)",
//                 display: "flex", alignItems: "center", justifyContent: "center",
//               }}>
//                 <Typography sx={{
//                   color: "white",
//                   fontSize: "0.9rem",
//                   fontWeight: 800,
//                   letterSpacing: 0.5,
//                   bgcolor: "#d32f2f",
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 1
//                 }}>
//                   OUT OF STOCK
//                 </Typography>
//               </Box>
//             )}
//           </Box>

//           {/* ADD / Quantity button */}
//           {quantity === 0 ? (
//             <Button
//               variant="outlined"
//               size="small"
//               onClick={handleAdd}
//               disabled={isOutOfStock}
//               sx={{
//                 width: "100%", height: 30, borderRadius: 1.5,
//                 borderColor: isOutOfStock ? "#ccc" : "#2e7d32",
//                 color: isOutOfStock ? "#999" : "#2e7d32",
//                 fontWeight: 800, fontSize: "0.8rem",
//                 textTransform: "none",
//                 boxShadow: isOutOfStock ? "none" : "0 1px 4px rgba(46,125,50,0.15)",
//                 "&:hover": {
//                   bgcolor: isOutOfStock ? "transparent" : "#e8f5e9",
//                   borderColor: isOutOfStock ? "#ccc" : "#1b5e20"
//                 },
//                 cursor: isOutOfStock ? "not-allowed" : "pointer",
//               }}
//             >
//               {isOutOfStock ? "SOLD OUT" : "ADD"}
//               {hasCustomization && !isOutOfStock && (
//                 <Typography component="span" sx={{ fontSize: "0.55rem", ml: 0.3, color: "#888", fontWeight: 400 }}>
//                   +
//                 </Typography>
//               )}
//             </Button>
//           ) : (
//             <Box sx={{
//               display: "flex", alignItems: "center", justifyContent: "space-between",
//               width: "100%", height: 30,
//               bgcolor: isOutOfStock ? "#9e9e9e" : "#2e7d32",
//               borderRadius: 1.5, overflow: "hidden",
//               boxShadow: isOutOfStock ? "none" : "0 2px 8px rgba(46,125,50,0.3)",
//             }}>
//               <IconButton size="small" onClick={handleRemove}
//                 sx={{
//                   color: "white", width: 30, height: 30, borderRadius: 0,
//                   "&:hover": { bgcolor: isOutOfStock ? "#757575" : "#1b5e20" }
//                 }}>
//                 <RemoveIcon sx={{ fontSize: 14 }} />
//               </IconButton>
//               <Typography sx={{ color: "white", fontWeight: 800, fontSize: "0.85rem", lineHeight: 1 }}>
//                 {quantity}
//               </Typography>
//               <IconButton size="small" onClick={handleAdd} disabled={isOutOfStock}
//                 sx={{
//                   color: "white", width: 30, height: 30, borderRadius: 0,
//                   cursor: isOutOfStock ? "not-allowed" : "pointer",
//                   "&:hover": { bgcolor: isOutOfStock ? "#757575" : "#1b5e20" }
//                 }}>
//                 <AddIcon sx={{ fontSize: 14 }} />
//               </IconButton>
//             </Box>
//           )}
//         </Box>

       
//       </Box>

//       {/* ── Customization Panel ── */}
//       <Collapse in={showCustomization}>
//         <Box sx={{ bgcolor: "#fafafa", borderTop: "1px solid #f0f0f0" }}>
//           {/* Panel Header */}
//           <Box sx={{
//             display: "flex", justifyContent: "space-between", alignItems: "center",
//             px: 2, py: 1, bgcolor: "#f5f5f5", borderBottom: "1px solid #ebebeb",
//           }}>
//             <Typography variant="body2" sx={{ fontWeight: 700, fontSize: "0.82rem", color: "#333" }}>
//               Customise your order
//             </Typography>
//             <IconButton size="small" onClick={() => setShowCustomization(false)} sx={{ p: 0.3, color: "#888" }}>
//               <CloseIcon sx={{ fontSize: 16 }} />
//             </IconButton>
//           </Box>

//           <Box sx={{ px: 2, pb: 2 }}>
//             {/* 🔥 OFFER INFO IN CUSTOMIZATION - FIXED */}
//             {bestOffer && (
//               <Box sx={{
//                 mt: 1.5, p: 1.2,
//                 bgcolor: "#e8f5e9",
//                 borderRadius: 2,
//                 border: "1px solid #c8e6c9",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1
//               }}>
//                 <LocalOfferIcon sx={{ fontSize: 16, color: "#2e7d32" }} />
//                 <Box>
//                   <Typography variant="caption" sx={{ fontWeight: 700, color: "#2e7d32", display: "block" }}>
//                     {bestOffer.discountType === "PERCENT"
//                       ? `${bestOffer.value}% OFF Applied!`
//                       : `₹${bestOffer.value} OFF Applied!`}
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: "#555", fontSize: "0.65rem" }}>
//                     You save ₹{savingAmount.toFixed(0)} on this item
//                   </Typography>
//                 </Box>
//               </Box>
//             )}

//             {/* ── Sizes ── */}
//             {item.sizes?.length > 0 && (
//               <Box sx={{ mt: 1.5 }}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
//                   <Typography variant="caption" sx={{ fontWeight: 700, fontSize: "0.78rem", color: "#333", textTransform: "uppercase", letterSpacing: 0.5 }}>
//                     Size
//                   </Typography>
//                   <Chip label="Required" size="small" sx={{ height: 16, fontSize: "0.6rem", bgcolor: "#fce4ec", color: "#c62828" }} />
//                 </Box>
//                 <FormControl component="fieldset" sx={{ width: "100%" }}>
//                   <RadioGroup value={selectedSize} onChange={(e) => setSelectedSize(e.target.value)}>
//                     {item.sizes.map((size) => {
//                       let sizePrice = size.price;
//                       let displaySizePrice = sizePrice;
//                       let sizeSaving = 0;

//                       if (bestOffer && bestOffer.discountType === "PERCENT") {
//                         let discount = (sizePrice * bestOffer.value) / 100;
//                         if (bestOffer.maxDiscount && discount > bestOffer.maxDiscount) {
//                           discount = bestOffer.maxDiscount;
//                         }
//                         displaySizePrice = sizePrice - discount;
//                         sizeSaving = discount;
//                       } else if (bestOffer && bestOffer.discountType === "FLAT") {
//                         displaySizePrice = Math.max(0, sizePrice - bestOffer.value);
//                         sizeSaving = bestOffer.value;
//                       }

//                       return (
//                         <FormControlLabel
//                           key={size.name}
//                           value={size.name}
//                           control={<Radio size="small" sx={{ color: "#2e7d32", "&.Mui-checked": { color: "#2e7d32" }, py: 0.5 }} />}
//                           label={
//                             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flex: 1, width: "100%" }}>
//                               <Typography variant="body2" sx={{ fontSize: "0.82rem" }}>{size.name}</Typography>
//                               <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                                 {displaySizePrice !== sizePrice && (
//                                   <Typography variant="caption" sx={{ fontSize: "0.7rem", color: "#aaa", textDecoration: "line-through" }}>
//                                     ₹{sizePrice}
//                                   </Typography>
//                                 )}
//                                 <Typography variant="body2" sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#1a1a1a" }}>
//                                   ₹{displaySizePrice}
//                                 </Typography>
//                                 {sizeSaving > 0 && (
//                                   <Chip
//                                     label={`Save ₹${sizeSaving}`}
//                                     size="small"
//                                     sx={{ height: 16, fontSize: '0.5rem', bgcolor: '#e8f5e9', color: '#2e7d32' }}
//                                   />
//                                 )}
//                               </Box>
//                             </Box>
//                           }
//                           sx={{
//                             width: "100%", mx: 0, mb: 0.3, py: 0.3, borderRadius: 1,
//                             bgcolor: selectedSize === size.name ? "#e8f5e9" : "transparent", px: 0.5
//                           }}
//                         />
//                       );
//                     })}
//                   </RadioGroup>
//                 </FormControl>
//               </Box>
//             )}

//             {/* ── Variants ── */}
//             {item.variants?.length > 0 && (
//               <Box sx={{ mt: 1.5 }}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
//                   <Typography variant="caption" sx={{ fontWeight: 700, fontSize: "0.78rem", color: "#333", textTransform: "uppercase", letterSpacing: 0.5 }}>
//                     Variant
//                   </Typography>
//                   <Chip label="Required" size="small" sx={{ height: 16, fontSize: "0.6rem", bgcolor: "#fce4ec", color: "#c62828" }} />
//                 </Box>
//                 <FormControl component="fieldset" sx={{ width: "100%" }}>
//                   <RadioGroup value={selectedVariant} onChange={(e) => setSelectedVariant(e.target.value)}>
//                     {item.variants.map((v) => (
//                       <FormControlLabel
//                         key={v.name}
//                         value={v.name}
//                         control={<Radio size="small" sx={{ color: "#2e7d32", "&.Mui-checked": { color: "#2e7d32" }, py: 0.5 }} />}
//                         label={
//                           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flex: 1 }}>
//                             <Typography variant="body2" sx={{ fontSize: "0.82rem" }}>{v.name}</Typography>
//                             {v.price > 0 && (
//                               <Typography variant="body2" sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#555" }}>+₹{v.price}</Typography>
//                             )}
//                           </Box>
//                         }
//                         sx={{
//                           width: "100%", mx: 0, mb: 0.3, py: 0.3, borderRadius: 1,
//                           bgcolor: selectedVariant === v.name ? "#e8f5e9" : "transparent", px: 0.5
//                         }}
//                       />
//                     ))}
//                   </RadioGroup>
//                 </FormControl>
//               </Box>
//             )}

//             {/* ── Addon Groups ── */}
//             {item.addonGroups?.map((group, idx) => (
//               <Box key={idx} sx={{ mt: 1.5 }}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
//                   <Typography variant="caption" sx={{ fontWeight: 700, fontSize: "0.78rem", color: "#333", textTransform: "uppercase", letterSpacing: 0.5 }}>
//                     {group.title}
//                   </Typography>
//                   <Chip
//                     label={group.required ? "Required" : "Optional"}
//                     size="small"
//                     sx={{
//                       height: 16, fontSize: "0.6rem",
//                       bgcolor: group.required ? "#fce4ec" : "#f5f5f5",
//                       color: group.required ? "#c62828" : "#888",
//                     }}
//                   />
//                   {group.multiSelect && (
//                     <Typography variant="caption" sx={{ color: "#aaa", fontSize: "0.65rem" }}>(Multiple)</Typography>
//                   )}
//                 </Box>
//                 <FormGroup>
//                   {group.items?.map((addon) => (
//                     <FormControlLabel
//                       key={addon.name}
//                       control={
//                         group.multiSelect ? (
//                           <Checkbox
//                             size="small"
//                             checked={selectedAddons.includes(addon.name)}
//                             onChange={() => handleAddonChange(addon.name, group)}
//                             sx={{ color: "#2e7d32", "&.Mui-checked": { color: "#2e7d32" }, py: 0.5 }}
//                           />
//                         ) : (
//                           <Radio
//                             size="small"
//                             checked={selectedAddons.includes(addon.name)}
//                             onChange={() => handleAddonChange(addon.name, group)}
//                             sx={{ color: "#2e7d32", "&.Mui-checked": { color: "#2e7d32" }, py: 0.5 }}
//                           />
//                         )
//                       }
//                       label={
//                         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flex: 1 }}>
//                           <Typography variant="body2" sx={{ fontSize: "0.82rem" }}>{addon.name}</Typography>
//                           <Typography variant="body2" sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#555" }}>+₹{addon.price}</Typography>
//                         </Box>
//                       }
//                       sx={{
//                         width: "100%", mx: 0, mb: 0.3, py: 0.3, borderRadius: 1,
//                         bgcolor: selectedAddons.includes(addon.name) ? "#e8f5e9" : "transparent", px: 0.5,
//                       }}
//                     />
//                   ))}
//                 </FormGroup>
//               </Box>
//             ))}

//             {/* ── Add to Cart CTA ── */}
//             <Box sx={{ display: "flex", gap: 1, mt: 2.5 }}>
//               <Button
//                 variant="outlined" size="small" fullWidth
//                 onClick={() => setShowCustomization(false)}
//                 sx={{
//                   borderRadius: 2, textTransform: "none", fontWeight: 600,
//                   borderColor: "#e0e0e0", color: "#666", fontSize: "0.8rem",
//                   "&:hover": { bgcolor: "#f5f5f5", borderColor: "#ccc" },
//                 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained" size="small" fullWidth
//                 onClick={handleAdd}
//                 sx={{
//                   borderRadius: 2, bgcolor: "#2e7d32", "&:hover": { bgcolor: "#1b5e20" },
//                   textTransform: "none", fontWeight: 700, fontSize: "0.82rem",
//                   boxShadow: "0 2px 8px rgba(46,125,50,0.3)",
//                 }}
//               >
//                 Add • ₹{calculateFinalPrice().toFixed(0)}
//                 {bestOffer && savingAmount > 0 && (
//                   <Typography component="span" sx={{ fontSize: "0.65rem", ml: 0.5, color: "rgba(255,255,255,0.9)" }}>
//                     (Save ₹{savingAmount.toFixed(0)})
//                   </Typography>
//                 )}
//               </Button>
//             </Box>
//           </Box>
//         </Box>
//       </Collapse>
//     </Card>
//   );
// };

// export default MenuItemCard;


import {
  Card,
  Typography,
  IconButton,
  Box,
  Button,
  CardMedia,
  Chip,
  Collapse,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  FormGroup,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import TuneIcon from "@mui/icons-material/Tune";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { addItem, removeItem } from "../../redux/slices/cartSlice";
import { useState, useEffect, useMemo } from "react";

const VegDot = ({ isVeg }) => (
  <Box
    sx={{
      width: 16,
      height: 16,
      borderRadius: "3px",
      border: `2px solid ${isVeg ? "#2e7d32" : "#c62828"}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}
  >
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        bgcolor: isVeg ? "#2e7d32" : "#c62828",
      }}
    />
  </Box>
);

const MenuItemCard = ({
  item,
  sx,
  categoryName,
  itemOffer = null,
  categoryOffer = null,
  isBogoEligible = false,
}) => {
  const dispatch = useDispatch();

  const [showCustomization, setShowCustomization] = useState(false);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [imgError, setImgError] = useState(false);

  const originalPrice = useMemo(() => {
    return Number(item.basePrice || item.price || 0);
  }, [item.basePrice, item.price]);

  const [bestOffer, setBestOffer] = useState(null);
  const [discountedPrice, setDiscountedPrice] = useState(null);
  const [savingAmount, setSavingAmount] = useState(0);

  const cartItem = useSelector((state) =>
    state.cart?.items?.find((i) => i._id === item._id)
  );
  const quantity = cartItem?.qty || 0;

  const hasCustomization =
    item.sizes?.length > 0 ||
    item.variants?.length > 0 ||
    item.addonGroups?.length > 0;

  // ============================================
  // 🔥 useEffect — sirf ITEM-scope offer ka discount show karo
  // Category offer item-level pe NAHI dikhega (cart-level pe lagega)
  // ============================================
  useEffect(() => {
    let bestDiscount = 0;
    let bestOfferData = null;

    // 🔥 Sirf ITEM scope wale offers lo
    if (
      itemOffer &&
      itemOffer.offerCategory === "DISCOUNT" &&
      itemOffer.scope === "ITEM"
    ) {
      let discount = 0;
      if (itemOffer.discountType === "PERCENT") {
        discount = (originalPrice * itemOffer.value) / 100;
        if (itemOffer.maxDiscount && discount > itemOffer.maxDiscount) {
          discount = itemOffer.maxDiscount;
        }
      } else {
        discount = Math.min(itemOffer.value, originalPrice);
      }

      if (discount > 0) {
        bestDiscount = discount;
        bestOfferData = {
          ...itemOffer,
          discountAmount: discount,
          type: "ITEM",
          saving: discount,
        };
      }
    }

    // ❌ Category offer item-level pe MAT lagao — cart-level pe lagega

    setBestOffer(bestOfferData);
    // 🔥 Discounted price + saving amount set karo
    setDiscountedPrice(bestDiscount > 0 ? originalPrice - bestDiscount : null);
    setSavingAmount(bestDiscount);
  }, [itemOffer, originalPrice, item.itemName]);

  const calculateFinalPrice = () => {
    let price = discountedPrice !== null ? discountedPrice : originalPrice;

    if (selectedSize && item.sizes) {
      const s = item.sizes.find((s) => s.name === selectedSize);
      if (s) {
        price = s.price;
        if (bestOffer && bestOffer.discountType === "PERCENT") {
          let discount = (price * bestOffer.value) / 100;
          if (bestOffer.maxDiscount && discount > bestOffer.maxDiscount) {
            discount = bestOffer.maxDiscount;
          }
          price = price - discount;
        } else if (bestOffer && bestOffer.discountType === "FLAT") {
          price = Math.max(0, price - bestOffer.value);
        }
      }
    }

    if (selectedVariant && item.variants) {
      const v = item.variants.find((v) => v.name === selectedVariant);
      if (v?.price) price += v.price;
    }

    if (selectedAddons.length > 0) {
      price += selectedAddons.reduce((sum, addonName) => {
        for (const group of item.addonGroups || []) {
          const a = group.items?.find((a) => a.name === addonName);
          if (a) return sum + a.price;
        }
        return sum;
      }, 0);
    }

    return price;
  };

  const handleAdd = () => {
    if (hasCustomization && !showCustomization) {
      setShowCustomization(true);
      return;
    }

    if (item.sizes?.length > 0 && !selectedSize) {
      alert("Please select a size");
      return;
    }
    if (item.variants?.length > 0 && !selectedVariant) {
      alert("Please select a variant");
      return;
    }
    for (const group of item.addonGroups || []) {
      if (group.required && group.items?.length > 0) {
        const ok = selectedAddons.some((addon) =>
          group.items.some((a) => a.name === addon)
        );
        if (!ok) {
          alert(`Please select from "${group.title}"`);
          return;
        }
      }
    }

    // Calculate prices
    let itemOriginalPrice = 0;
    let itemFinalPrice = 0;

    if (selectedSize && item.sizes) {
      const size = item.sizes.find((s) => s.name === selectedSize);
      if (size) {
        itemOriginalPrice += size.price;
        itemFinalPrice += size.price;
      }
    } else {
      itemOriginalPrice += Number(item.basePrice || item.price || 0);
      itemFinalPrice += Number(item.basePrice || item.price || 0);
    }

    if (selectedVariant && item.variants) {
      const variant = item.variants.find((v) => v.name === selectedVariant);
      if (variant?.price) {
        itemOriginalPrice += variant.price;
        itemFinalPrice += variant.price;
      }
    }

    if (selectedAddons.length > 0) {
      selectedAddons.forEach((addonName) => {
        for (const group of item.addonGroups || []) {
          const addon = group.items?.find((a) => a.name === addonName);
          if (addon) {
            itemOriginalPrice += addon.price;
            itemFinalPrice += addon.price;
          }
        }
      });
    }

    // 🔥 ITEM-scope offer ka discount lagao
    let discountAmount = 0;
    let appliedOfferData = null;

    if (bestOffer) {
      if (bestOffer.discountType === "PERCENT") {
        discountAmount = (itemFinalPrice * bestOffer.value) / 100;
        if (bestOffer.maxDiscount && discountAmount > bestOffer.maxDiscount) {
          discountAmount = bestOffer.maxDiscount;
        }
      } else {
        discountAmount = Math.min(bestOffer.value, itemFinalPrice);
      }

      itemFinalPrice = itemFinalPrice - discountAmount;
      appliedOfferData = {
        offerId: bestOffer._id,
        offerCode: bestOffer.offerCode,
        offerTitle: bestOffer.title,
        offerCategory: bestOffer.offerCategory || "DISCOUNT",
        discountType: bestOffer.discountType,
        discountValue: bestOffer.value,
        discountAmount: discountAmount,
        isFree: false,
      };
    }

    dispatch(
      addItem({
        ...item,
        categoryId: item.categoryId || item.category?._id || item.category,
        price: itemFinalPrice,
        originalPrice: itemOriginalPrice,
        totalPrice: itemFinalPrice,
        discountedPrice: itemFinalPrice,
        discountAmount: discountAmount,
        selectedSize,
        selectedVariant,
        selectedAddons: selectedAddons.map((name) => {
          for (const group of item.addonGroups || []) {
            const a = group.items?.find((a) => a.name === name);
            if (a) return { name: a.name, price: a.price };
          }
          return { name, price: 0 };
        }),
        categoryName: categoryName || item.categoryName,
        qty: 1,
        appliedOffer: appliedOfferData,
        isBogoEligible: isBogoEligible,
        savingPerItem: discountAmount,
        savingTotal: discountAmount,
        hasOffer: bestOffer !== null,
        offerType: bestOffer?.type,
      })
    );
    setShowCustomization(false);
  };

  const handleRemove = () => {
    if (quantity > 0) dispatch(removeItem(item._id));
  };

  const handleAddonChange = (addonName, group) => {
    if (group.multiSelect) {
      setSelectedAddons((prev) =>
        prev.includes(addonName)
          ? prev.filter((a) => a !== addonName)
          : [...prev, addonName]
      );
    } else {
      setSelectedAddons([addonName]);
    }
  };

  const itemImage = !imgError && item.image ? item.image : null;
  const displayPrice =
    discountedPrice !== null ? discountedPrice : originalPrice;
  const hasOffer = bestOffer !== null || isBogoEligible;
  const isOutOfStock = item.isAvailable === false;
  const showDiscount =
    discountedPrice !== null && discountedPrice < originalPrice && bestOffer;

  return (
    <Card
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        bgcolor: "white",
        borderRadius: 0,
        opacity: isOutOfStock ? 0.7 : 1,
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", p: 1.5, gap: 1.5, alignItems: "flex-start" }}>
        {/* ── Left: Text content ── */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          {/* Veg dot + Name */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 0.8,
              mb: 0.5,
            }}
          >
            <Box sx={{ mt: 0.3, flexShrink: 0 }}>
              <VegDot isVeg={item.isVeg} />
            </Box>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                fontSize: "0.9rem",
                color: "#1a1a1a",
                lineHeight: 1.3,
                wordBreak: "break-word",
              }}
            >
              {item.itemName}
            </Typography>
          </Box>

          {/* 🔥 Price row — Zomato/Swiggy style */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.8,
              mb: 0.5,
              flexWrap: "wrap",
            }}
          >
            {/* Discounted price (green) */}
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1rem",
                color: showDiscount ? "#2e7d32" : "#1a1a1a",
              }}
            >
              ₹{displayPrice.toFixed(0)}
            </Typography>

            {/* Original price (strikethrough) */}
            {showDiscount && (
              <Typography
                sx={{
                  fontSize: "0.8rem",
                  color: "#999",
                  textDecoration: "line-through",
                  fontWeight: 500,
                }}
              >
                ₹{originalPrice.toFixed(0)}
              </Typography>
            )}
          </Box>

          {/* 🔥 Discount chip — below price (Zomato/Swiggy style) */}
          {showDiscount && bestOffer && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                mb: 0.5,
              }}
            >
              <Chip
                label={
                  bestOffer.discountType === "PERCENT"
                    ? `${bestOffer.value}% OFF`
                    : `₹${bestOffer.value} OFF`
                }
                size="small"
                icon={
                  <LocalOfferIcon
                    sx={{ fontSize: "11px !important", ml: "4px !important" }}
                  />
                }
                sx={{
                  height: 20,
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  bgcolor: "#e8f5e9",
                  color: "#2e7d32",
                  border: "1px solid #c8e6c9",
                  "& .MuiChip-icon": { color: "#2e7d32" },
                }}
              />

              {/* Save chip — optional */}
              {savingAmount > 0 && (
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.65rem",
                    color: "#2e7d32",
                    fontWeight: 600,
                  }}
                >
                  Save ₹{savingAmount.toFixed(0)}
                </Typography>
              )}
            </Box>
          )}

          {/* Description */}
          {item.description && (
            <Typography
              variant="caption"
              sx={{
                color: "#888",
                fontSize: "0.75rem",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                lineHeight: 1.4,
                mb: 0.5,
              }}
            >
              {item.description}
            </Typography>
          )}

          {/* Tags row */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 0.5 }}>
            {hasCustomization && (
              <Chip
                label="Customisable"
                size="small"
                icon={
                  <TuneIcon
                    sx={{ fontSize: "11px !important", ml: "4px !important" }}
                  />
                }
                sx={{
                  height: 19,
                  fontSize: "0.62rem",
                  fontWeight: 600,
                  bgcolor: "#fff8e1",
                  color: "#f57c00",
                  border: "1px solid #ffe0b2",
                  "& .MuiChip-icon": { color: "#f57c00" },
                }}
              />
            )}

            {/* BOGO OFFER BADGE */}
            {isBogoEligible && !bestOffer && (
              <Chip
                label="BOGO"
                size="small"
                icon={
                  <LocalOfferIcon
                    sx={{ fontSize: "11px !important", ml: "4px !important" }}
                  />
                }
                sx={{
                  height: 19,
                  fontSize: "0.62rem",
                  fontWeight: 700,
                  bgcolor: "#fff3e0",
                  color: "#e65100",
                  border: "1px solid #ffe0b2",
                  "& .MuiChip-icon": { color: "#e65100" },
                }}
              />
            )}
          </Box>
        </Box>

        {/* ── Right: Image + Add button ── */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexShrink: 0,
            width: 100,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 100,
              height: 100,
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "#f5f5f5",
              mb: 1,
            }}
          >
            {itemImage ? (
              <CardMedia
                component="img"
                image={itemImage}
                alt={item.itemName}
                onError={() => setImgError(true)}
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "2rem",
                  bgcolor: item.isVeg ? "#f1f8e9" : "#fce4ec",
                }}
              >
                {item.isVeg ? "🥗" : "🍗"}
              </Box>
            )}

            {/* 🔥 OFFER BADGE ON IMAGE */}
            {hasOffer && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bgcolor: bestOffer ? "#ff9800" : "#e91e63",
                  py: 0.2,
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: "0.55rem",
                    fontWeight: 800,
                    letterSpacing: 0.3,
                  }}
                >
                  {bestOffer
                    ? `${bestOffer.value}${bestOffer.discountType === "PERCENT" ? "%" : "₹"} OFF`
                    : "BOGO"}
                </Typography>
              </Box>
            )}

            {/* Bestseller ribbon */}
            {item.isBestseller && !hasOffer && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bgcolor: "#e65100",
                  py: 0.2,
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: "0.55rem",
                    fontWeight: 800,
                    letterSpacing: 0.3,
                  }}
                >
                  ⭐ BESTSELLER
                </Typography>
              </Box>
            )}

            {/* OUT OF STOCK BADGE */}
            {isOutOfStock && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  bgcolor: "rgba(0,0,0,0.6)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: "0.9rem",
                    fontWeight: 800,
                    letterSpacing: 0.5,
                    bgcolor: "#d32f2f",
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 1,
                  }}
                >
                  OUT OF STOCK
                </Typography>
              </Box>
            )}
          </Box>

          {quantity === 0 ? (
            <Button
              variant="outlined"
              size="small"
              onClick={handleAdd}
              disabled={isOutOfStock}
              sx={{
                width: "100%",
                height: 30,
                borderRadius: 1.5,
                borderColor: isOutOfStock ? "#ccc" : "#2e7d32",
                color: isOutOfStock ? "#999" : "#2e7d32",
                fontWeight: 800,
                fontSize: "0.8rem",
                textTransform: "none",
                boxShadow: isOutOfStock
                  ? "none"
                  : "0 1px 4px rgba(46,125,50,0.15)",
                "&:hover": {
                  bgcolor: isOutOfStock ? "transparent" : "#e8f5e9",
                  borderColor: isOutOfStock ? "#ccc" : "#1b5e20",
                },
                cursor: isOutOfStock ? "not-allowed" : "pointer",
              }}
            >
              {isOutOfStock ? "SOLD OUT" : "ADD"}
              {hasCustomization && !isOutOfStock && (
                <Typography
                  component="span"
                  sx={{
                    fontSize: "0.55rem",
                    ml: 0.3,
                    color: "#888",
                    fontWeight: 400,
                  }}
                >
                  +
                </Typography>
              )}
            </Button>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                height: 30,
                bgcolor: isOutOfStock ? "#9e9e9e" : "#2e7d32",
                borderRadius: 1.5,
                overflow: "hidden",
                boxShadow: isOutOfStock
                  ? "none"
                  : "0 2px 8px rgba(46,125,50,0.3)",
              }}
            >
              <IconButton
                size="small"
                onClick={handleRemove}
                sx={{
                  color: "white",
                  width: 30,
                  height: 30,
                  borderRadius: 0,
                  "&:hover": {
                    bgcolor: isOutOfStock ? "#757575" : "#1b5e20",
                  },
                }}
              >
                <RemoveIcon sx={{ fontSize: 14 }} />
              </IconButton>
              <Typography
                sx={{
                  color: "white",
                  fontWeight: 800,
                  fontSize: "0.85rem",
                  lineHeight: 1,
                }}
              >
                {quantity}
              </Typography>
              <IconButton
                size="small"
                onClick={handleAdd}
                disabled={isOutOfStock}
                sx={{
                  color: "white",
                  width: 30,
                  height: 30,
                  borderRadius: 0,
                  cursor: isOutOfStock ? "not-allowed" : "pointer",
                  "&:hover": {
                    bgcolor: isOutOfStock ? "#757575" : "#1b5e20",
                  },
                }}
              >
                <AddIcon sx={{ fontSize: 14 }} />
              </IconButton>
            </Box>
          )}
        </Box>
      </Box>

      {/* ── Customization Panel ── */}
      <Collapse in={showCustomization}>
        <Box sx={{ bgcolor: "#fafafa", borderTop: "1px solid #f0f0f0" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              py: 1,
              bgcolor: "#f5f5f5",
              borderBottom: "1px solid #ebebeb",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: 700, fontSize: "0.82rem", color: "#333" }}
            >
              Customise your order
            </Typography>
            <IconButton
              size="small"
              onClick={() => setShowCustomization(false)}
              sx={{ p: 0.3, color: "#888" }}
            >
              <CloseIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>

          <Box sx={{ px: 2, pb: 2 }}>
            {bestOffer && (
              <Box
                sx={{
                  mt: 1.5,
                  p: 1.2,
                  bgcolor: "#e8f5e9",
                  borderRadius: 2,
                  border: "1px solid #c8e6c9",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <LocalOfferIcon sx={{ fontSize: 16, color: "#2e7d32" }} />
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      color: "#2e7d32",
                      display: "block",
                    }}
                  >
                    {bestOffer.discountType === "PERCENT"
                      ? `${bestOffer.value}% OFF Applied!`
                      : `₹${bestOffer.value} OFF Applied!`}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: "#555", fontSize: "0.65rem" }}
                  >
                    You save ₹{savingAmount.toFixed(0)} on this item
                  </Typography>
                </Box>
              </Box>
            )}

            {/* Sizes */}
            {item.sizes?.length > 0 && (
              <Box sx={{ mt: 1.5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.78rem",
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                    }}
                  >
                    Size
                  </Typography>
                  <Chip
                    label="Required"
                    size="small"
                    sx={{
                      height: 16,
                      fontSize: "0.6rem",
                      bgcolor: "#fce4ec",
                      color: "#c62828",
                    }}
                  />
                </Box>
                <FormControl component="fieldset" sx={{ width: "100%" }}>
                  <RadioGroup
                    value={selectedSize}
                    onChange={(e) => setSelectedSize(e.target.value)}
                  >
                    {item.sizes.map((size) => {
                      let sizePrice = size.price;
                      let displaySizePrice = sizePrice;
                      let sizeSaving = 0;

                      if (bestOffer && bestOffer.discountType === "PERCENT") {
                        let discount = (sizePrice * bestOffer.value) / 100;
                        if (
                          bestOffer.maxDiscount &&
                          discount > bestOffer.maxDiscount
                        ) {
                          discount = bestOffer.maxDiscount;
                        }
                        displaySizePrice = sizePrice - discount;
                        sizeSaving = discount;
                      } else if (
                        bestOffer &&
                        bestOffer.discountType === "FLAT"
                      ) {
                        displaySizePrice = Math.max(
                          0,
                          sizePrice - bestOffer.value
                        );
                        sizeSaving = bestOffer.value;
                      }

                      return (
                        <FormControlLabel
                          key={size.name}
                          value={size.name}
                          control={
                            <Radio
                              size="small"
                              sx={{
                                color: "#2e7d32",
                                "&.Mui-checked": { color: "#2e7d32" },
                                py: 0.5,
                              }}
                            />
                          }
                          label={
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flex: 1,
                                width: "100%",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "0.82rem" }}
                              >
                                {size.name}
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                {displaySizePrice !== sizePrice && (
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontSize: "0.7rem",
                                      color: "#aaa",
                                      textDecoration: "line-through",
                                    }}
                                  >
                                    ₹{sizePrice}
                                  </Typography>
                                )}
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: "0.82rem",
                                    fontWeight: 700,
                                    color: "#1a1a1a",
                                  }}
                                >
                                  ₹{displaySizePrice}
                                </Typography>
                                {sizeSaving > 0 && (
                                  <Chip
                                    label={`Save ₹${sizeSaving}`}
                                    size="small"
                                    sx={{
                                      height: 16,
                                      fontSize: "0.5rem",
                                      bgcolor: "#e8f5e9",
                                      color: "#2e7d32",
                                    }}
                                  />
                                )}
                              </Box>
                            </Box>
                          }
                          sx={{
                            width: "100%",
                            mx: 0,
                            mb: 0.3,
                            py: 0.3,
                            borderRadius: 1,
                            bgcolor:
                              selectedSize === size.name
                                ? "#e8f5e9"
                                : "transparent",
                            px: 0.5,
                          }}
                        />
                      );
                    })}
                  </RadioGroup>
                </FormControl>
              </Box>
            )}

            {/* Variants */}
            {item.variants?.length > 0 && (
              <Box sx={{ mt: 1.5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.78rem",
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                    }}
                  >
                    Variant
                  </Typography>
                  <Chip
                    label="Required"
                    size="small"
                    sx={{
                      height: 16,
                      fontSize: "0.6rem",
                      bgcolor: "#fce4ec",
                      color: "#c62828",
                    }}
                  />
                </Box>
                <FormControl component="fieldset" sx={{ width: "100%" }}>
                  <RadioGroup
                    value={selectedVariant}
                    onChange={(e) => setSelectedVariant(e.target.value)}
                  >
                    {item.variants.map((v) => (
                      <FormControlLabel
                        key={v.name}
                        value={v.name}
                        control={
                          <Radio
                            size="small"
                            sx={{
                              color: "#2e7d32",
                              "&.Mui-checked": { color: "#2e7d32" },
                              py: 0.5,
                            }}
                          />
                        }
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flex: 1,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "0.82rem" }}
                            >
                              {v.name}
                            </Typography>
                            {v.price > 0 && (
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: "0.82rem",
                                  fontWeight: 700,
                                  color: "#555",
                                }}
                              >
                                +₹{v.price}
                              </Typography>
                            )}
                          </Box>
                        }
                        sx={{
                          width: "100%",
                          mx: 0,
                          mb: 0.3,
                          py: 0.3,
                          borderRadius: 1,
                          bgcolor:
                            selectedVariant === v.name
                              ? "#e8f5e9"
                              : "transparent",
                          px: 0.5,
                        }}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Box>
            )}

            {/* Addons */}
            {item.addonGroups?.map((group, idx) => (
              <Box key={idx} sx={{ mt: 1.5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.78rem",
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                    }}
                  >
                    {group.title}
                  </Typography>
                  <Chip
                    label={group.required ? "Required" : "Optional"}
                    size="small"
                    sx={{
                      height: 16,
                      fontSize: "0.6rem",
                      bgcolor: group.required ? "#fce4ec" : "#f5f5f5",
                      color: group.required ? "#c62828" : "#888",
                    }}
                  />
                  {group.multiSelect && (
                    <Typography
                      variant="caption"
                      sx={{ color: "#aaa", fontSize: "0.65rem" }}
                    >
                      (Multiple)
                    </Typography>
                  )}
                </Box>
                <FormGroup>
                  {group.items?.map((addon) => (
                    <FormControlLabel
                      key={addon.name}
                      control={
                        group.multiSelect ? (
                          <Checkbox
                            size="small"
                            checked={selectedAddons.includes(addon.name)}
                            onChange={() =>
                              handleAddonChange(addon.name, group)
                            }
                            sx={{
                              color: "#2e7d32",
                              "&.Mui-checked": { color: "#2e7d32" },
                              py: 0.5,
                            }}
                          />
                        ) : (
                          <Radio
                            size="small"
                            checked={selectedAddons.includes(addon.name)}
                            onChange={() =>
                              handleAddonChange(addon.name, group)
                            }
                            sx={{
                              color: "#2e7d32",
                              "&.Mui-checked": { color: "#2e7d32" },
                              py: 0.5,
                            }}
                          />
                        )
                      }
                      label={
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flex: 1,
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ fontSize: "0.82rem" }}
                          >
                            {addon.name}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "0.82rem",
                              fontWeight: 700,
                              color: "#555",
                            }}
                          >
                            +₹{addon.price}
                          </Typography>
                        </Box>
                      }
                      sx={{
                        width: "100%",
                        mx: 0,
                        mb: 0.3,
                        py: 0.3,
                        borderRadius: 1,
                        bgcolor: selectedAddons.includes(addon.name)
                          ? "#e8f5e9"
                          : "transparent",
                        px: 0.5,
                      }}
                    />
                  ))}
                </FormGroup>
              </Box>
            ))}

            {/* CTA */}
            <Box sx={{ display: "flex", gap: 1, mt: 2.5 }}>
              <Button
                variant="outlined"
                size="small"
                fullWidth
                onClick={() => setShowCustomization(false)}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  borderColor: "#e0e0e0",
                  color: "#666",
                  fontSize: "0.8rem",
                  "&:hover": { bgcolor: "#f5f5f5", borderColor: "#ccc" },
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                size="small"
                fullWidth
                onClick={handleAdd}
                sx={{
                  borderRadius: 2,
                  bgcolor: "#2e7d32",
                  "&:hover": { bgcolor: "#1b5e20" },
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.82rem",
                  boxShadow: "0 2px 8px rgba(46,125,50,0.3)",
                }}
              >
                Add • ₹{calculateFinalPrice().toFixed(0)}
                {bestOffer && savingAmount > 0 && (
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "0.65rem",
                      ml: 0.5,
                      color: "rgba(255,255,255,0.9)",
                    }}
                  >
                    (Save ₹{savingAmount.toFixed(0)})
                  </Typography>
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </Collapse>
    </Card>
  );
};

export default MenuItemCard;
// import {
//   Card,
//   Typography,
//   IconButton,
//   Box,
//   Button,
//   CardMedia,
//   Chip,
//   Collapse,
//   FormControl,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Checkbox,
//   FormGroup,
//   Divider,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import RemoveIcon from "@mui/icons-material/Remove";
// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// import TuneIcon from "@mui/icons-material/Tune";
// import CloseIcon from "@mui/icons-material/Close";
// import { useDispatch, useSelector } from "react-redux";
// import { addItem, removeItem } from "../../redux/slices/cartSlice";
// import { useState, useEffect, useMemo } from "react";

// const VegDot = ({ isVeg }) => (
//   <Box
//     sx={{
//       width: 16,
//       height: 16,
//       borderRadius: "3px",
//       border: `2px solid ${isVeg ? "#2e7d32" : "#c62828"}`,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       flexShrink: 0,
//     }}
//   >
//     <Box
//       sx={{
//         width: 8,
//         height: 8,
//         borderRadius: "50%",
//         bgcolor: isVeg ? "#2e7d32" : "#c62828",
//       }}
//     />
//   </Box>
// );

// const MenuItemCard = ({
//   item,
//   sx,
//   categoryName,
//   itemOffer = null,
//   categoryOffer = null,
//   isBogoEligible = false,
// }) => {
//   const dispatch = useDispatch();

//   const [showCustomization, setShowCustomization] = useState(false);
//   const [selectedSize, setSelectedSize] = useState(null);
//   const [selectedVariant, setSelectedVariant] = useState(null);
//   const [selectedAddons, setSelectedAddons] = useState([]);
//   const [imgError, setImgError] = useState(false);

//   const originalPrice = useMemo(() => {
//     return Number(item.basePrice || item.price || 0);
//   }, [item.basePrice, item.price]);

//   const [bestOffer, setBestOffer] = useState(null);
//   const [discountedPrice, setDiscountedPrice] = useState(null);
//   const [savingAmount, setSavingAmount] = useState(0);

//   const cartItem = useSelector((state) =>
//     state.cart?.items?.find((i) => i._id === item._id)
//   );
//   const quantity = cartItem?.qty || 0;

//   const hasCustomization =
//     item.sizes?.length > 0 ||
//     item.variants?.length > 0 ||
//     item.addonGroups?.length > 0;

//   // ============================================
//   // 🔥 useEffect — SIRF ITEM-scope offer ka badge dikhao
//   // Category offer item-level pe NAHI dikhayenge
//   // ============================================
//   useEffect(() => {
//     let bestDiscount = 0;
//     let bestOfferData = null;

//     // 🔥 Sirf ITEM scope wale offers lo (chip/badge ke liye)
//     if (
//       itemOffer &&
//       itemOffer.offerCategory === "DISCOUNT" &&
//       itemOffer.scope === "ITEM"
//     ) {
//       let discount = 0;
//       if (itemOffer.discountType === "PERCENT") {
//         discount = (originalPrice * itemOffer.value) / 100;
//         if (itemOffer.maxDiscount && discount > itemOffer.maxDiscount) {
//           discount = itemOffer.maxDiscount;
//         }
//       } else {
//         discount = Math.min(itemOffer.value, originalPrice);
//       }

//       if (discount > 0) {
//         bestDiscount = discount;
//         bestOfferData = {
//           ...itemOffer,
//           discountAmount: discount,
//           type: "ITEM",
//           saving: discount,
//         };
//       }
//     }

//     // ❌ Category offer item-level pe MAT lagao
//     // Cart-level pe `applyOfferToCart` lagega

//     setBestOffer(bestOfferData);
//     // 🔥 Item-level pe discounted price NAHI dikhayenge
//     setDiscountedPrice(null);
//     setSavingAmount(0);
//   }, [itemOffer, originalPrice, item.itemName]);

//   const calculateFinalPrice = () => {
//     let price = originalPrice;

//     if (selectedSize && item.sizes) {
//       const s = item.sizes.find((s) => s.name === selectedSize);
//       if (s) {
//         price = s.price;
//       }
//     }

//     if (selectedVariant && item.variants) {
//       const v = item.variants.find((v) => v.name === selectedVariant);
//       if (v?.price) price += v.price;
//     }

//     if (selectedAddons.length > 0) {
//       price += selectedAddons.reduce((sum, addonName) => {
//         for (const group of item.addonGroups || []) {
//           const a = group.items?.find((a) => a.name === addonName);
//           if (a) return sum + a.price;
//         }
//         return sum;
//       }, 0);
//     }

//     return price;
//   };

//   const handleAdd = () => {
//     if (hasCustomization && !showCustomization) {
//       setShowCustomization(true);
//       return;
//     }

//     if (item.sizes?.length > 0 && !selectedSize) {
//       alert("Please select a size");
//       return;
//     }
//     if (item.variants?.length > 0 && !selectedVariant) {
//       alert("Please select a variant");
//       return;
//     }
//     for (const group of item.addonGroups || []) {
//       if (group.required && group.items?.length > 0) {
//         const ok = selectedAddons.some((addon) =>
//           group.items.some((a) => a.name === addon)
//         );
//         if (!ok) {
//           alert(`Please select from "${group.title}"`);
//           return;
//         }
//       }
//     }

//     // Calculate prices
//     let itemOriginalPrice = 0;
//     let itemFinalPrice = 0;

//     if (selectedSize && item.sizes) {
//       const size = item.sizes.find((s) => s.name === selectedSize);
//       if (size) {
//         itemOriginalPrice += size.price;
//         itemFinalPrice += size.price;
//       }
//     } else {
//       itemOriginalPrice += Number(item.basePrice || item.price || 0);
//       itemFinalPrice += Number(item.basePrice || item.price || 0);
//     }

//     if (selectedVariant && item.variants) {
//       const variant = item.variants.find((v) => v.name === selectedVariant);
//       if (variant?.price) {
//         itemOriginalPrice += variant.price;
//         itemFinalPrice += variant.price;
//       }
//     }

//     if (selectedAddons.length > 0) {
//       selectedAddons.forEach((addonName) => {
//         for (const group of item.addonGroups || []) {
//           const addon = group.items?.find((a) => a.name === addonName);
//           if (addon) {
//             itemOriginalPrice += addon.price;
//             itemFinalPrice += addon.price;
//           }
//         }
//       });
//     }

//     // 🔥 Item-level pe koi discount NAHI lagayenge
//     // Discount cart-level pe `applyOfferToCart` se lagega
//     const discountAmount = 0;
//     const appliedOfferData = null;

//     dispatch(
//       addItem({
//         ...item,
//         categoryId: item.categoryId || item.category?._id || item.category,
//         price: itemFinalPrice, // = original price
//         originalPrice: itemOriginalPrice,
//         totalPrice: itemFinalPrice,
//         discountedPrice: itemFinalPrice, // = original
//         discountAmount: 0, // 🔥 No item discount
//         selectedSize,
//         selectedVariant,
//         selectedAddons: selectedAddons.map((name) => {
//           for (const group of item.addonGroups || []) {
//             const a = group.items?.find((a) => a.name === name);
//             if (a) return { name: a.name, price: a.price };
//           }
//           return { name, price: 0 };
//         }),
//         categoryName: categoryName || item.categoryName,
//         qty: 1,
//         appliedOffer: null, // 🔥 No item offer applied
//         isBogoEligible: isBogoEligible,
//         savingPerItem: 0,
//         savingTotal: 0,
//         hasOffer: false,
//         offerType: null,
//       })
//     );
//     setShowCustomization(false);
//   };

//   const handleRemove = () => {
//     if (quantity > 0) dispatch(removeItem(item._id));
//   };

//   const handleAddonChange = (addonName, group) => {
//     if (group.multiSelect) {
//       setSelectedAddons((prev) =>
//         prev.includes(addonName)
//           ? prev.filter((a) => a !== addonName)
//           : [...prev, addonName]
//       );
//     } else {
//       setSelectedAddons([addonName]);
//     }
//   };

//   const itemImage = !imgError && item.image ? item.image : null;
//   const displayPrice = originalPrice; // 🔥 Always original price
//   const hasOffer = bestOffer !== null || isBogoEligible;
//   const isOutOfStock = item.isAvailable === false;

//   return (
//     <Card
//       elevation={0}
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         width: "100%",
//         bgcolor: "white",
//         borderRadius: 0,
//         opacity: isOutOfStock ? 0.7 : 1,
//         ...sx,
//       }}
//     >
//       <Box sx={{ display: "flex", p: 1.5, gap: 1.5, alignItems: "flex-start" }}>
//         {/* ── Left: Text content ── */}
//         <Box sx={{ flex: 1, minWidth: 0 }}>
//           {/* Veg dot + Name */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "flex-start",
//               gap: 0.8,
//               mb: 0.5,
//             }}
//           >
//             <Box sx={{ mt: 0.3, flexShrink: 0 }}>
//               <VegDot isVeg={item.isVeg} />
//             </Box>
//             <Typography
//               variant="subtitle2"
//               sx={{
//                 fontWeight: 700,
//                 fontSize: "0.9rem",
//                 color: "#1a1a1a",
//                 lineHeight: 1.3,
//                 wordBreak: "break-word",
//               }}
//             >
//               {item.itemName}
//             </Typography>
//           </Box>

//           {/* Price — always original */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               mb: 0.5,
//               flexWrap: "wrap",
//             }}
//           >
//             <Typography
//               sx={{
//                 fontWeight: 700,
//                 fontSize: "0.95rem",
//                 color: "#1a1a1a",
//               }}
//             >
//               ₹{displayPrice.toFixed(0)}
//             </Typography>
//           </Box>

//           {/* Description */}
//           {item.description && (
//             <Typography
//               variant="caption"
//               sx={{
//                 color: "#888",
//                 fontSize: "0.75rem",
//                 display: "-webkit-box",
//                 WebkitLineClamp: 2,
//                 WebkitBoxOrient: "vertical",
//                 overflow: "hidden",
//                 lineHeight: 1.4,
//                 mb: 0.5,
//               }}
//             >
//               {item.description}
//             </Typography>
//           )}

//           {/* Tags row */}
//           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 0.5 }}>
//             {hasCustomization && (
//               <Chip
//                 label="Customisable"
//                 size="small"
//                 icon={
//                   <TuneIcon
//                     sx={{ fontSize: "11px !important", ml: "4px !important" }}
//                   />
//                 }
//                 sx={{
//                   height: 19,
//                   fontSize: "0.62rem",
//                   fontWeight: 600,
//                   bgcolor: "#fff8e1",
//                   color: "#f57c00",
//                   border: "1px solid #ffe0b2",
//                   "& .MuiChip-icon": { color: "#f57c00" },
//                 }}
//               />
//             )}

//             {/* DISCOUNT OFFER BADGE — sirf ITEM scope */}
//             {bestOffer && (
//               <Chip
//                 label={
//                   bestOffer.discountType === "PERCENT"
//                     ? `${bestOffer.value}% OFF`
//                     : `₹${bestOffer.value} OFF`
//                 }
//                 size="small"
//                 icon={
//                   <LocalOfferIcon
//                     sx={{ fontSize: "11px !important", ml: "4px !important" }}
//                   />
//                 }
//                 sx={{
//                   height: 19,
//                   fontSize: "0.62rem",
//                   fontWeight: 700,
//                   bgcolor: "#e8f5e9",
//                   color: "#2e7d32",
//                   border: "1px solid #c8e6c9",
//                   "& .MuiChip-icon": { color: "#2e7d32" },
//                 }}
//               />
//             )}

//             {/* BOGO OFFER BADGE */}
//             {isBogoEligible && !bestOffer && (
//               <Chip
//                 label="BOGO"
//                 size="small"
//                 icon={
//                   <LocalOfferIcon
//                     sx={{ fontSize: "11px !important", ml: "4px !important" }}
//                   />
//                 }
//                 sx={{
//                   height: 19,
//                   fontSize: "0.62rem",
//                   fontWeight: 700,
//                   bgcolor: "#fff3e0",
//                   color: "#e65100",
//                   border: "1px solid #ffe0b2",
//                   "& .MuiChip-icon": { color: "#e65100" },
//                 }}
//               />
//             )}
//           </Box>
//         </Box>

//         {/* ── Right: Image + Add button ── */}
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             flexShrink: 0,
//             width: 100,
//           }}
//         >
//           <Box
//             sx={{
//               position: "relative",
//               width: 100,
//               height: 100,
//               borderRadius: 2,
//               overflow: "hidden",
//               bgcolor: "#f5f5f5",
//               mb: 1,
//             }}
//           >
//             {itemImage ? (
//               <CardMedia
//                 component="img"
//                 image={itemImage}
//                 alt={item.itemName}
//                 onError={() => setImgError(true)}
//                 sx={{ width: "100%", height: "100%", objectFit: "cover" }}
//               />
//             ) : (
//               <Box
//                 sx={{
//                   width: "100%",
//                   height: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: "2rem",
//                   bgcolor: item.isVeg ? "#f1f8e9" : "#fce4ec",
//                 }}
//               >
//                 {item.isVeg ? "🥗" : "🍗"}
//               </Box>
//             )}

//             {hasOffer && (
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bgcolor: bestOffer ? "#ff9800" : "#e91e63",
//                   py: 0.2,
//                   textAlign: "center",
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     color: "white",
//                     fontSize: "0.55rem",
//                     fontWeight: 800,
//                     letterSpacing: 0.3,
//                   }}
//                 >
//                   {bestOffer
//                     ? `${bestOffer.value}${bestOffer.discountType === "PERCENT" ? "%" : "₹"} OFF`
//                     : "BOGO"}
//                 </Typography>
//               </Box>
//             )}

//             {item.isBestseller && !hasOffer && (
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bgcolor: "#e65100",
//                   py: 0.2,
//                   textAlign: "center",
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     color: "white",
//                     fontSize: "0.55rem",
//                     fontWeight: 800,
//                     letterSpacing: 0.3,
//                   }}
//                 >
//                   ⭐ BESTSELLER
//                 </Typography>
//               </Box>
//             )}

//             {isOutOfStock && (
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bottom: 0,
//                   bgcolor: "rgba(0,0,0,0.6)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     color: "white",
//                     fontSize: "0.9rem",
//                     fontWeight: 800,
//                     letterSpacing: 0.5,
//                     bgcolor: "#d32f2f",
//                     px: 1.5,
//                     py: 0.5,
//                     borderRadius: 1,
//                   }}
//                 >
//                   OUT OF STOCK
//                 </Typography>
//               </Box>
//             )}
//           </Box>

//           {quantity === 0 ? (
//             <Button
//               variant="outlined"
//               size="small"
//               onClick={handleAdd}
//               disabled={isOutOfStock}
//               sx={{
//                 width: "100%",
//                 height: 30,
//                 borderRadius: 1.5,
//                 borderColor: isOutOfStock ? "#ccc" : "#2e7d32",
//                 color: isOutOfStock ? "#999" : "#2e7d32",
//                 fontWeight: 800,
//                 fontSize: "0.8rem",
//                 textTransform: "none",
//                 boxShadow: isOutOfStock
//                   ? "none"
//                   : "0 1px 4px rgba(46,125,50,0.15)",
//                 "&:hover": {
//                   bgcolor: isOutOfStock ? "transparent" : "#e8f5e9",
//                   borderColor: isOutOfStock ? "#ccc" : "#1b5e20",
//                 },
//                 cursor: isOutOfStock ? "not-allowed" : "pointer",
//               }}
//             >
//               {isOutOfStock ? "SOLD OUT" : "ADD"}
//               {hasCustomization && !isOutOfStock && (
//                 <Typography
//                   component="span"
//                   sx={{
//                     fontSize: "0.55rem",
//                     ml: 0.3,
//                     color: "#888",
//                     fontWeight: 400,
//                   }}
//                 >
//                   +
//                 </Typography>
//               )}
//             </Button>
//           ) : (
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 width: "100%",
//                 height: 30,
//                 bgcolor: isOutOfStock ? "#9e9e9e" : "#2e7d32",
//                 borderRadius: 1.5,
//                 overflow: "hidden",
//                 boxShadow: isOutOfStock
//                   ? "none"
//                   : "0 2px 8px rgba(46,125,50,0.3)",
//               }}
//             >
//               <IconButton
//                 size="small"
//                 onClick={handleRemove}
//                 sx={{
//                   color: "white",
//                   width: 30,
//                   height: 30,
//                   borderRadius: 0,
//                   "&:hover": {
//                     bgcolor: isOutOfStock ? "#757575" : "#1b5e20",
//                   },
//                 }}
//               >
//                 <RemoveIcon sx={{ fontSize: 14 }} />
//               </IconButton>
//               <Typography
//                 sx={{
//                   color: "white",
//                   fontWeight: 800,
//                   fontSize: "0.85rem",
//                   lineHeight: 1,
//                 }}
//               >
//                 {quantity}
//               </Typography>
//               <IconButton
//                 size="small"
//                 onClick={handleAdd}
//                 disabled={isOutOfStock}
//                 sx={{
//                   color: "white",
//                   width: 30,
//                   height: 30,
//                   borderRadius: 0,
//                   cursor: isOutOfStock ? "not-allowed" : "pointer",
//                   "&:hover": {
//                     bgcolor: isOutOfStock ? "#757575" : "#1b5e20",
//                   },
//                 }}
//               >
//                 <AddIcon sx={{ fontSize: 14 }} />
//               </IconButton>
//             </Box>
//           )}
//         </Box>
//       </Box>

//       {/* ── Customization Panel ── */}
//       <Collapse in={showCustomization}>
//         <Box sx={{ bgcolor: "#fafafa", borderTop: "1px solid #f0f0f0" }}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               px: 2,
//               py: 1,
//               bgcolor: "#f5f5f5",
//               borderBottom: "1px solid #ebebeb",
//             }}
//           >
//             <Typography
//               variant="body2"
//               sx={{ fontWeight: 700, fontSize: "0.82rem", color: "#333" }}
//             >
//               Customise your order
//             </Typography>
//             <IconButton
//               size="small"
//               onClick={() => setShowCustomization(false)}
//               sx={{ p: 0.3, color: "#888" }}
//             >
//               <CloseIcon sx={{ fontSize: 16 }} />
//             </IconButton>
//           </Box>

//           <Box sx={{ px: 2, pb: 2 }}>
//             {bestOffer && (
//               <Box
//                 sx={{
//                   mt: 1.5,
//                   p: 1.2,
//                   bgcolor: "#e8f5e9",
//                   borderRadius: 2,
//                   border: "1px solid #c8e6c9",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                 }}
//               >
//                 <LocalOfferIcon sx={{ fontSize: 16, color: "#2e7d32" }} />
//                 <Box>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       fontWeight: 700,
//                       color: "#2e7d32",
//                       display: "block",
//                     }}
//                   >
//                     {bestOffer.discountType === "PERCENT"
//                       ? `${bestOffer.value}% OFF Applied!`
//                       : `₹${bestOffer.value} OFF Applied!`}
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                     sx={{ color: "#555", fontSize: "0.65rem" }}
//                   >
//                     You save ₹{bestOffer.discountAmount.toFixed(0)} on this item
//                   </Typography>
//                 </Box>
//               </Box>
//             )}

//             {/* Sizes */}
//             {item.sizes?.length > 0 && (
//               <Box sx={{ mt: 1.5 }}>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 0.5,
//                     mb: 1,
//                   }}
//                 >
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       fontWeight: 700,
//                       fontSize: "0.78rem",
//                       color: "#333",
//                       textTransform: "uppercase",
//                       letterSpacing: 0.5,
//                     }}
//                   >
//                     Size
//                   </Typography>
//                   <Chip
//                     label="Required"
//                     size="small"
//                     sx={{
//                       height: 16,
//                       fontSize: "0.6rem",
//                       bgcolor: "#fce4ec",
//                       color: "#c62828",
//                     }}
//                   />
//                 </Box>
//                 <FormControl component="fieldset" sx={{ width: "100%" }}>
//                   <RadioGroup
//                     value={selectedSize}
//                     onChange={(e) => setSelectedSize(e.target.value)}
//                   >
//                     {item.sizes.map((size) => (
//                       <FormControlLabel
//                         key={size.name}
//                         value={size.name}
//                         control={
//                           <Radio
//                             size="small"
//                             sx={{
//                               color: "#2e7d32",
//                               "&.Mui-checked": { color: "#2e7d32" },
//                               py: 0.5,
//                             }}
//                           />
//                         }
//                         label={
//                           <Box
//                             sx={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               alignItems: "center",
//                               flex: 1,
//                               width: "100%",
//                             }}
//                           >
//                             <Typography
//                               variant="body2"
//                               sx={{ fontSize: "0.82rem" }}
//                             >
//                               {size.name}
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               sx={{
//                                 fontSize: "0.82rem",
//                                 fontWeight: 700,
//                                 color: "#1a1a1a",
//                               }}
//                             >
//                               ₹{size.price}
//                             </Typography>
//                           </Box>
//                         }
//                         sx={{
//                           width: "100%",
//                           mx: 0,
//                           mb: 0.3,
//                           py: 0.3,
//                           borderRadius: 1,
//                           bgcolor:
//                             selectedSize === size.name
//                               ? "#e8f5e9"
//                               : "transparent",
//                           px: 0.5,
//                         }}
//                       />
//                     ))}
//                   </RadioGroup>
//                 </FormControl>
//               </Box>
//             )}

//             {/* Variants */}
//             {item.variants?.length > 0 && (
//               <Box sx={{ mt: 1.5 }}>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 0.5,
//                     mb: 1,
//                   }}
//                 >
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       fontWeight: 700,
//                       fontSize: "0.78rem",
//                       color: "#333",
//                       textTransform: "uppercase",
//                       letterSpacing: 0.5,
//                     }}
//                   >
//                     Variant
//                   </Typography>
//                   <Chip
//                     label="Required"
//                     size="small"
//                     sx={{
//                       height: 16,
//                       fontSize: "0.6rem",
//                       bgcolor: "#fce4ec",
//                       color: "#c62828",
//                     }}
//                   />
//                 </Box>
//                 <FormControl component="fieldset" sx={{ width: "100%" }}>
//                   <RadioGroup
//                     value={selectedVariant}
//                     onChange={(e) => setSelectedVariant(e.target.value)}
//                   >
//                     {item.variants.map((v) => (
//                       <FormControlLabel
//                         key={v.name}
//                         value={v.name}
//                         control={
//                           <Radio
//                             size="small"
//                             sx={{
//                               color: "#2e7d32",
//                               "&.Mui-checked": { color: "#2e7d32" },
//                               py: 0.5,
//                             }}
//                           />
//                         }
//                         label={
//                           <Box
//                             sx={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               alignItems: "center",
//                               flex: 1,
//                             }}
//                           >
//                             <Typography
//                               variant="body2"
//                               sx={{ fontSize: "0.82rem" }}
//                             >
//                               {v.name}
//                             </Typography>
//                             {v.price > 0 && (
//                               <Typography
//                                 variant="body2"
//                                 sx={{
//                                   fontSize: "0.82rem",
//                                   fontWeight: 700,
//                                   color: "#555",
//                                 }}
//                               >
//                                 +₹{v.price}
//                               </Typography>
//                             )}
//                           </Box>
//                         }
//                         sx={{
//                           width: "100%",
//                           mx: 0,
//                           mb: 0.3,
//                           py: 0.3,
//                           borderRadius: 1,
//                           bgcolor:
//                             selectedVariant === v.name
//                               ? "#e8f5e9"
//                               : "transparent",
//                           px: 0.5,
//                         }}
//                       />
//                     ))}
//                   </RadioGroup>
//                 </FormControl>
//               </Box>
//             )}

//             {/* Addons */}
//             {item.addonGroups?.map((group, idx) => (
//               <Box key={idx} sx={{ mt: 1.5 }}>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 0.5,
//                     mb: 1,
//                   }}
//                 >
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       fontWeight: 700,
//                       fontSize: "0.78rem",
//                       color: "#333",
//                       textTransform: "uppercase",
//                       letterSpacing: 0.5,
//                     }}
//                   >
//                     {group.title}
//                   </Typography>
//                   <Chip
//                     label={group.required ? "Required" : "Optional"}
//                     size="small"
//                     sx={{
//                       height: 16,
//                       fontSize: "0.6rem",
//                       bgcolor: group.required ? "#fce4ec" : "#f5f5f5",
//                       color: group.required ? "#c62828" : "#888",
//                     }}
//                   />
//                   {group.multiSelect && (
//                     <Typography
//                       variant="caption"
//                       sx={{ color: "#aaa", fontSize: "0.65rem" }}
//                     >
//                       (Multiple)
//                     </Typography>
//                   )}
//                 </Box>
//                 <FormGroup>
//                   {group.items?.map((addon) => (
//                     <FormControlLabel
//                       key={addon.name}
//                       control={
//                         group.multiSelect ? (
//                           <Checkbox
//                             size="small"
//                             checked={selectedAddons.includes(addon.name)}
//                             onChange={() =>
//                               handleAddonChange(addon.name, group)
//                             }
//                             sx={{
//                               color: "#2e7d32",
//                               "&.Mui-checked": { color: "#2e7d32" },
//                               py: 0.5,
//                             }}
//                           />
//                         ) : (
//                           <Radio
//                             size="small"
//                             checked={selectedAddons.includes(addon.name)}
//                             onChange={() =>
//                               handleAddonChange(addon.name, group)
//                             }
//                             sx={{
//                               color: "#2e7d32",
//                               "&.Mui-checked": { color: "#2e7d32" },
//                               py: 0.5,
//                             }}
//                           />
//                         )
//                       }
//                       label={
//                         <Box
//                           sx={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             flex: 1,
//                           }}
//                         >
//                           <Typography
//                             variant="body2"
//                             sx={{ fontSize: "0.82rem" }}
//                           >
//                             {addon.name}
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{
//                               fontSize: "0.82rem",
//                               fontWeight: 700,
//                               color: "#555",
//                             }}
//                           >
//                             +₹{addon.price}
//                           </Typography>
//                         </Box>
//                       }
//                       sx={{
//                         width: "100%",
//                         mx: 0,
//                         mb: 0.3,
//                         py: 0.3,
//                         borderRadius: 1,
//                         bgcolor: selectedAddons.includes(addon.name)
//                           ? "#e8f5e9"
//                           : "transparent",
//                         px: 0.5,
//                       }}
//                     />
//                   ))}
//                 </FormGroup>
//               </Box>
//             ))}

//             {/* CTA */}
//             <Box sx={{ display: "flex", gap: 1, mt: 2.5 }}>
//               <Button
//                 variant="outlined"
//                 size="small"
//                 fullWidth
//                 onClick={() => setShowCustomization(false)}
//                 sx={{
//                   borderRadius: 2,
//                   textTransform: "none",
//                   fontWeight: 600,
//                   borderColor: "#e0e0e0",
//                   color: "#666",
//                   fontSize: "0.8rem",
//                   "&:hover": { bgcolor: "#f5f5f5", borderColor: "#ccc" },
//                 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained"
//                 size="small"
//                 fullWidth
//                 onClick={handleAdd}
//                 sx={{
//                   borderRadius: 2,
//                   bgcolor: "#2e7d32",
//                   "&:hover": { bgcolor: "#1b5e20" },
//                   textTransform: "none",
//                   fontWeight: 700,
//                   fontSize: "0.82rem",
//                   boxShadow: "0 2px 8px rgba(46,125,50,0.3)",
//                 }}
//               >
//                 Add • ₹{calculateFinalPrice().toFixed(0)}
//               </Button>
//             </Box>
//           </Box>
//         </Box>
//       </Collapse>
//     </Card>
//   );
// };

// export default MenuItemCard;
